import path, { createRouteObject } from 'Router/path'
import component from 'Components/index'
import { RouteRecordRaw } from 'vue-router';

const router: RouteRecordRaw[] = [
    createRouteObject({
        path: path.profile,
        component: component.ProfilePage
    }),
    createRouteObject({
        path: path.infoLanding,
        component: component.InfoLandingPage
    }),
    createRouteObject({
        path: path.changePassword,
        component: component.ChangePasswordPage
    }),
    createRouteObject({
        path: path.updateInfo,
        component: component.UpdateInfoPage
    }),
    createRouteObject({
        path: path.settings,
        component: component.SettingsPage
    }),
    createRouteObject({
        path: path.changeLanguage,
        component: component.ChangeLanguagePage
    }),
    createRouteObject({
        path: path.accountOrders,
        component: component.AccountOrdersPage
    }),
    createRouteObject({
        path: path.cashFlow,
        component: component.CashFlowPage
    }),
]

export default router;